module.exports = __webpack_public_path__ + "img/individual-active.ded87557.svg";